import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.99976 6.6666C9.80976 6.6666 9.62059 6.73077 9.46643 6.85993L4.46643 11.0266C4.11309 11.3208 4.06476 11.8466 4.35976 12.1999C4.65393 12.5533 5.17893 12.6008 5.53309 12.3066L10.0089 8.5766L14.4773 12.1724C14.8356 12.4608 15.3606 12.4041 15.6489 12.0458C15.9373 11.6874 15.8806 11.1633 15.5223 10.8741L10.5223 6.85077C10.3698 6.72827 10.1848 6.6666 9.99976 6.6666Z",
      fill: _ctx.color
    }, null, 8, _hoisted_2)
  ]))
}